import { lazy, Suspense } from 'react';
import { ConfigurationCanvasLeftPanel } from '../configuration-canvas-panel';
import { useSelector } from 'react-redux';
import { DocumentationContextProvider } from '../../documentation/context/DocumentationContext';
import { CenteredCircularProgress } from '../../common/CenteredCircularProgress';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { GlobalRenderer } from '../global-renderer/GlobalRenderer';

const DocumentationDialog = lazy(() => import('../../documentation/DocumentationDialog'));

const DocumentationPage = () => {
  const defaultCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  return (
    <GlobalRenderer>
      <DocumentationContextProvider crmOrgId={defaultCrmOrgId ?? ''}>
        <ConfigurationCanvasLeftPanel sx={{ pb: '24px' }} withExpandedModeButton>
          <Suspense fallback={<CenteredCircularProgress />}>
            <DocumentationDialog crmOrgId={defaultCrmOrgId ?? ''} hideAddObjectButton={false} />
          </Suspense>
        </ConfigurationCanvasLeftPanel>
      </DocumentationContextProvider>
    </GlobalRenderer>
  );
};

export { DocumentationPage };
